module.exports = __webpack_public_path__ + "static/media/loader.30e06fdc.svg";